import { application } from '../axios.service'

export const ServiceAuth = {
    login: (payload) => application.post('/login', payload),
    check: () => application.get('/'),
}
